export default {
  bind: function (el, binding) {
    if (binding.value === false) {
      return;
    }
    const isEditableTarget = event => {
      const target = event.target;
      return (
        target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        (target instanceof HTMLElement && target.isContentEditable)
      );
    };
    el.addEventListener('keydown', event => {
      if (event.key === 'Enter' && !isEditableTarget(event)) {
        el.click();
      }
    });
    el.addEventListener('keyup', event => {
      if (event.code === 'Space' && !isEditableTarget(event)) {
        el.click();
      }
    });
    el.setAttribute('tabindex', '0');
    el.setAttribute('role', 'button');
  },
};
